
  export const style = {
    api: {
      apiProduction: "https://aterpa.prd.appnoz.com.br/",
      newApiProduction: "null",
      samlUrl: "https://saml-aterpa.appnoz.com.br/auth/login/aterpa",
      nameProfile: "Aterpa",
      hostHeader: "aterpa",
    },

    icons: {
      loginIcon: "https://timcoo-geral.s3.amazonaws.com/Logos/logotipo_aterpa.png",
      secondaryLogonLogo: "null",
      menuIcon: localStorage.getItem("menuIcon") || "https://timcoo-geral.s3.amazonaws.com/Logos/logotipo_aterpa.png",
      browserLogo: "https://timcoo-geral.s3.amazonaws.com/Logos/favicon_client_aterpa.png",
    },

    shareAttributes: {
      shareImage: "https://timcoo-geral.s3.amazonaws.com/Logos/logotipo_aterpa.png",
      shareTitle: "Noz - Plataforma de comunicação",
      shareDescription: "O NOZ é um aplicativo de comunicação personalizado, onde é possível criar conteúdos de acordo com a segmentação do seu público de maneira gamificada.",
    },

    names: {
      nameApp: localStorage.getItem("nameApp") || "NOZ",
      nameScore: "AterpaCoins",
      nameStore: "Mercado Aterpa",
      nameAcademy: localStorage.getItem("nameAcademy") || "Educaterpa",
      nameTeam: localStorage.getItem("nameTeam") || "Time",
      nameCalendar: localStorage.getItem("nameCalendar") || "Calendário",
      nameTools: localStorage.getItem("nameTools") || "Ferramentas",
    },

    colors: {
      primaryColor: localStorage.getItem("primaryColor") || "#CDCDCD",
      secondaryColor: localStorage.getItem("secondaryColor") || "#CDCDCD",
      tertiaryColor: "",
    },

    variables: {
      gamificationEnabled: true,
      child_profiles: [],
      hasPrivacyPolicies: false,
      externalUse: false,
      customClient: false,
      customMenuItem: true,
      autoRegister: false,
      recaptchaVersion: "V1",
      showBirthday: "true"
    },
  };
